module.exports = __webpack_public_path__ + "static/img/R404A.f5c29a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R404A.jpg
// module id = zaCV
// module chunks = 1